import _extends from "@babel/runtime/helpers/extends";
import { Overlay, usePopover } from "@react-aria/overlays";
import React from "react";
import { Box } from "../Styling";
export const ComboBoxPopover = _ref => {
  let {
    children,
    popoverRef,
    state,
    ...rest
  } = _ref;
  const {
    popoverProps
  } = usePopover({
    ...rest,
    popoverRef
  }, state);
  return /*#__PURE__*/React.createElement(Overlay, null, /*#__PURE__*/React.createElement(Box, _extends({}, popoverProps, {
    ref: popoverRef
  }), children));
};
//# sourceMappingURL=ComboBoxPopover.js.map